import React from "react";
import "./Footer.css"

export function Footer() {
    return (
        <footer className="footer">
            <div className=" d-flex py-2 justify-content-evenly align-items-center rep mt-2">
                <div className="d-flex flex-column justify-content-center ">
                    <h6 className="font-weight-bold">กรมพัฒนาฝีมือแรงงาน</h6>
                    <h6 className="font-weight-bold">กระทรวงเเรงงาน</h6>
                    <h6 className="font-weight-bold">ถ.มิตรไมตรี ดินแดง กรุงเทพฯ 10400</h6>
                </div>
                <div className="d-flex flex-column justify-content-center">
                    <h6>สายด่วน:1506</h6>
                    <h6>โทรศัพท์:02-248-3393</h6>
                </div>
                <div className="d-flex flex-column justify-content-center">
                    <h6>อีเมล:webmaster@dsd.go.th</h6>
                </div>
                </div>
        </footer>
    );
}